<template>
  <div id="orderManagement">
    <div class="contentRight2">
      <div class="rightHead">
        <div style="margin:0 0 0 25px;font-size:15px;padding-top:16px;color:#707070;">订单管理</div>
      </div>
      <div class="head">
        <div class="row">
          <div class="headInput" style="width:300px">
            <el-input size="small" v-model="tradeNo" placeholder="搜索订单号" @blur="searchContentBlur"></el-input>
          </div>
          <div style="margin-left:20px;">
            <el-date-picker
              v-model="value1"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>

          <!-- <el-button size="small" style="margin-left:10px;height:32px">今天</el-button>
          <el-button size="small" style="height:32px">近7天</el-button>
          <el-button size="small" style="height:32px">近30天</el-button>-->
        </div>
        <div style="margin-top:10px;">
          <el-select size="small" v-model="shopId" placeholder="请选择">
            <el-option
              v-for="item in shopList"
              :key="item.storeName"
              :label="item.storeName"
              :value="item.shopStoreId"
            ></el-option>
          </el-select>
          <el-select size="small" v-model="cashierId" placeholder="收银员">
            <el-option
              v-for="item in workerList.cashierList"
              :key="item.shopWorkerUserId"
              :label="item.fullName"
              :value="item.shopWorkerUserId"
            ></el-option>
          </el-select>
          <el-select size="small" v-model="salesId" placeholder="销售员">
            <el-option
              v-for="item in workerList.salesList"
              :key="item.shopWorkerUserId"
              :label="item.fullName"
              :value="item.shopWorkerUserId"
            ></el-option>
          </el-select>
		  <div style="width:215px;display: inline-block;">
		    <el-input size="small" v-model="phoneNum" placeholder="搜索手机号"></el-input>
		  </div>
        </div>
        <div style="margin-top:10px;">
          <el-button size="small" @click="search" type="primary">搜索</el-button>
          <el-button size="small" @click="clearSearch">重置</el-button>
          <!-- <el-button size="small">订单导出</el-button> -->
        </div>
      </div>

      <div class="content" 
      v-loading="loading"
    :data="tableData"
    element-loading-text="拼命加载中"
    style="width: 100%"
      >
        <!-- 订单标签栏 -->
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="全部" name="first">
            <div v-if="isShow">
              <div class="table" v-for="(item1,index1) in commodityList.list" :key="index1">
                <div class="tableHead row">
                  <div>创建时间：{{item1.createTime}}</div>
                  <div>订单号：{{item1.tradeNo}}</div>
                  <div class="alignCenter">
                    <img style="margin-right:5px;" src="../../assets/icon/ggmd.png" alt />
                    {{item1.shopName}}
                  </div>
                  <div v-if="item1.orderCategory = 10">钱如潮订单</div>
                  <div>收银员：{{item1.cashierUserFullName}}</div>
                  <div>销售员：{{item1.saleFullName}}</div>
                </div>
                <div class="commodityList row">
                  <div class="commodity">
                    <div
                      v-for="(item,index) in item1.products"
                      @click="hrefDetail(item1)"
                      :key="index"
                    >
                      <!-- <img style="margin: 0 20px;" :src="item.goodsImage" alt /> -->
                      <!-- <div class="column">
                        <div>{{item.goodsName}} <span v-if="item.specDesc">({{item.specDesc}})</span></div>
                        <div
                          style="color:gray;margin-top:10px"
                          v-if="item.goodsBarCode"
                        >商品条码：{{item.goodsBarCode}}</div>
                        <div style="color:gray;margin-top:10px" v-if="!item.goodsBarCode">商品条码：无</div>
                      </div>-->
                      <div v-if="index<5" class="commodityItem row alignCenter">
                       <div class="totoName">{{item.goodsName}} <span v-if="item.specDesc">({{item.specDesc}})</span> </div>
                        <div class="toto">单价：￥{{item.retailPrice}}</div>
                        <div class="toto" v-if="item.discountPrice">折后价：￥{{item.discountPrice}}</div>
                        <div class="toto" v-if="!item.discountPrice">---</div>
                        <div class="toto">{{item.qrcBuyCount}}{{item.goodsUnit}}</div>
                        <div>{{item.totalDiscountPrice ? '折后价总计：'+ item.totalDiscountPrice : '原价总计：'+ item.totalRetailPrice}}</div>
                        <!-- <div class="toto">小计：￥{{item.totalTurnoverPrice}}</div> -->
                      </div>
                    </div>
                    <div
                      style="margin-left:20px;color:gray;margin-bottom:20px"
                      v-if="item1.products.length>5"
                    >等{{item1.products.length}}个商品</div>
                  </div>
                  <div class="price column">
                    <div>总数：{{item1.qrcBuyCount}}</div>
                    <div>合计：￥{{item1.totalRetailPrice }}</div>
                    <div
                      v-if="item1.shopPromotionData.length!=0"
                    >{{item1.shopPromotionData[0].name}}</div>
                    <div v-else>优惠券：无</div>
                    <div>优惠：￥{{item1.totalDiscountPrice}}</div>
                    <div>
                      应收金额：
                      <span style="color:red">￥{{item1.gainMoney}}</span>
                    </div>
                    <div v-if="item1.orderStatus == '有退款'|| item1.orderStatus == '有退款退货'">
                      退款金额：
                      <span style="color:red">￥{{item1.refundMoney}}</span>
                    </div>
                  </div>
                  <div class="state alignCenter column">
                    <div
                      style="margin-top:27px"
                      :style="{color:(item1.orderStatus == '有退款' || item1.orderStatus == '有退款退货'?'blue':'')}"
                    >{{item1.orderStatus}}</div>
                    <div @click="hrefDetail(item1)" class="orderJump">订单详情</div>
                  </div>
                  <div id="operate" class="operate justCenter">
                    <div style="margin-top:27px">
                      <!-- <el-button size="small" type="primary">打印小票</el-button> -->
                      <!-- <el-button size="small">去发货</el-button> -->
                      <el-button size="small" @click="open(item1)">备注</el-button>
                    </div>
                  </div>
                </div>
                <div class="bottom" v-if="item1.orderMark || item1.refundRemark">
                  <div v-if="item1.orderMark">
                    商家备注：
                    <span style="color:red">{{item1.orderMark}}</span>
                  </div>
                  <div v-if="item1.refundRemark">
                    退款备注：
                    <span style="color:red">{{item1.refundRemark}}</span>
                  </div>
                </div>
              </div>
              <!-- //分页 -->
              <div class="block" style="float:right;margin-top:10px;">
                <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage4"
                  :page-size="10"
                  layout="total, prev, pager, next, jumper"
                  :total="totalCount"
                ></el-pagination>
              </div>
            </div>
            <div v-else style="margin-top:20px">暂无订单信息</div>
          </el-tab-pane>
          <el-tab-pane label="待付款" name="second">
            <div v-if="isShow">
              <div class="table" v-for="(item1,index1) in commodityList.list" :key="index1">
                <div class="tableHead row">
                  <div>创建时间：{{item1.createTime}}</div>
                  <div>订单号：{{item1.tradeNo}}</div>
                  <div class="alignCenter">
                    <img style="margin-right:5px;" src="../../assets/icon/ggmd.png" alt />
                    {{item1.shopName}}
                  </div>
                  <div v-if="item1.orderCategory = 10">钱如潮订单</div>
                </div>
                <div class="commodityList row">
                  <div class="commodity">
                    <div
                      v-for="(item,index) in item1.products"
                      @click="hrefDetail(item1)"
                      :key="index"
                    >
                      <div v-if="index<5" class="commodityItem row alignCenter">
                        <div class="totoName">{{item.goodsName}} <span v-if="item.specDesc">({{item.specDesc}})</span></div>
                        <div class="toto">单价：￥{{item.retailPrice}}</div>
                        <div class="toto" v-if="item.discountPrice">折后价：￥{{item.discountPrice}}</div>
                        <div class="toto" v-if="!item.discountPrice">---</div>
                        <div class="toto">{{item.qrcBuyCount}}{{item.goodsUnit}}</div>
                        <div>{{item.totalDiscountPrice ? '折后价总计：'+ item.totalDiscountPrice : '原价总计：'+ item.totalRetailPrice}}</div>
                        <!-- <div class="toto">小计：￥{{item.totalTurnoverPrice}}</div> -->
                      </div>
                    </div>
                    <div
                      style="margin-left:20px;color:gray;margin-bottom:20px"
                      v-if="item1.products.length>5"
                    >等{{item1.products.length}}个商品</div>
                  </div>
                  <div class="price column">
                    <div>总数：{{item1.qrcBuyCount}}</div>
                    <div>合计：￥{{item1.totalRetailPrice }}</div>
                    <div
                      v-if="item1.shopPromotionData.length!=0"
                    >{{item1.shopPromotionData[0].name}}</div>
                    <div v-else>优惠券：无</div>
                    <div>优惠：￥{{item1.totalDiscountPrice}}</div>
                    <div>
                      应收金额：
                      <span style="color:red">￥{{item1.gainMoney}}</span>
                    </div>
                    
                  </div>
                  <div class="state alignCenter column">
                    <div style="margin-top:27px">{{item1.orderStatus}}</div>
                    <div @click="hrefDetail(item1)" class="orderJump">订单详情</div>
                  </div>
                  <div id="operate" class="operate justCenter">
                    <div style="margin-top:27px">
                      <!-- <el-button size="small" type="primary">打印小票</el-button>
                      <el-button size="small">去发货</el-button>-->
                      <el-button size="small" @click="open(item1)">备注</el-button>
                    </div>
                  </div>
                </div>
                <div class="bottom" v-if="item1.orderMark || item1.refundRemark">
                  <div v-if="item1.orderMark">
                    商家备注：
                    <span style="color:red">{{item1.orderMark}}</span>
                  </div>
                  <div v-if="item1.refundRemark">
                    退款备注：
                    <span style="color:red">{{item1.refundRemark }}</span>
                  </div>
                </div>
              </div>
              <!-- //分页 -->
              <div class="block" style="float:right;margin-top:10px;">
                <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage4"
                  :page-size="10"
                  layout="total, prev, pager, next, jumper"
                  :total="totalCount"
                ></el-pagination>
              </div>
            </div>
            <div v-else style="margin-top:20px">暂无订单信息</div>
          </el-tab-pane>
          <!-- <el-tab-pane label="已退货退款" name="third">已退货退款</el-tab-pane> -->
          <!-- <el-tab-pane label="已发货" name="fourth">已发货</el-tab-pane> -->
          <el-tab-pane label="已完成" name="fifth">
            <div v-if="isShow">
              <div class="table" v-for="(item1,index1) in commodityList.list" :key="index1">
                <div class="tableHead row">
                  <div>创建时间：{{item1.createTime}}</div>
                  <div>订单号：{{item1.tradeNo}}</div>
                  <div class="alignCenter">
                    <img style="margin-right:5px;" src="../../assets/icon/ggmd.png" alt />
                    {{item1.shopName}}
                  </div>
                  <div v-if="item1.orderCategory = 10">钱如潮订单</div>
                </div>
                <div class="commodityList row">
                  <div class="commodity">
                    <div
                      v-for="(item,index) in item1.products"
                      @click="hrefDetail(item1)"
                      :key="index"
                    >
                      <div v-if="index<5" class="commodityItem row alignCenter">
                        <div class="totoName">{{item.goodsName}} <span v-if="item.specDesc">({{item.specDesc}})</span></div>
                        <div class="toto">单价：￥{{item.retailPrice}}</div>
                        <div class="toto" v-if="item.discountPrice">折后价：￥{{item.discountPrice}}</div>
                        <div class="toto" v-if="!item.discountPrice">---</div>
                        <div class="toto">{{item.qrcBuyCount}}{{item.goodsUnit}}</div>
                        <div>{{item.totalDiscountPrice ? '折后价总计：'+ item.totalDiscountPrice : '原价总计：'+ item.totalRetailPrice}}</div>
                        <!-- <div class="toto">小计：￥{{item.totalTurnoverPrice}}</div> -->
                      </div>
                    </div>
                    <div
                      style="margin-left:20px;color:gray;margin-bottom:20px"
                      v-if="item1.products.length>5"
                    >等{{item1.products.length}}个商品</div>
                  </div>
                  <div class="price column">
                    <div>总数：{{item1.qrcBuyCount}}</div>
                    <div>合计：￥{{item1.totalRetailPrice}}</div>
                    <div
                      v-if="item1.shopPromotionData.length!=0"
                    >{{item1.shopPromotionData[0].name}}</div>
                    <div v-else>优惠券：无</div>
                    <div>优惠：￥{{item1.totalDiscountPrice}}</div>
                    <div>
                      应收金额：
                      <span style="color:red">￥{{item1.gainMoney}}</span>
                    </div>
                  </div>
                  <div class="state alignCenter column">
                    <div style="margin-top:27px">{{item1.orderStatus}}</div>
                    <div @click="hrefDetail(item1)" class="orderJump">订单详情</div>
                  </div>
                  <div id="operate" class="operate justCenter">
                    <div style="margin-top:27px">
                      <!-- <el-button size="small" type="primary">打印小票</el-button>
                      <el-button size="small">去发货</el-button>-->
                      <el-button size="small" @click="open(item1)">备注</el-button>
                    </div>
                  </div>
                </div>
                <div class="bottom" v-if="item1.orderMark || item1.refundRemark">
                  <div v-if="item1.orderMark">
                    商家备注：
                    <span style="color:red">{{item1.orderMark}}</span>
                  </div>
                  <div v-if="item1.refundRemark">
                    退款备注：
                    <span style="color:red">{{item1.refundRemark}}</span>
                  </div>
                </div>
              </div>
              <!-- //分页 -->
              <div class="block" style="float:right;margin-top:10px;">
                <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage4"
                  :page-size="10"
                  layout="total, prev, pager, next, jumper"
                  :total="totalCount"
                ></el-pagination>
              </div>
            </div>
            <div v-else style="margin-top:20px">暂无订单信息</div>
          </el-tab-pane>
          <el-tab-pane label="已关闭" name="sixth">
            <div v-if="isShow">
              <div class="table" v-for="(item1,index1) in commodityList.list" :key="index1">
                <div class="tableHead row">
                  <div>创建时间：{{item1.createTime}}</div>
                  <div>订单号：{{item1.tradeNo}}</div>
                  <div class="alignCenter">
                    <img style="margin-right:5px;" src="../../assets/icon/ggmd.png" alt />
                    {{item1.shopName}}
                  </div>
                  <div v-if="item1.orderCategory = 10">钱如潮订单</div>
                </div>
                <div class="commodityList row">
                  <div class="commodity">
                    <div
                      v-for="(item,index) in item1.products"
                      @click="hrefDetail(item1)"
                      :key="index"
                    >
                      <div v-if="index<5" class="commodityItem row alignCenter">
                         <div class="totoName">{{item.goodsName}} <span v-if="item.specDesc">({{item.specDesc}})</span></div>
                        <div class="toto">单价：￥{{item.retailPrice}}</div>
                        <div class="toto" v-if="item.discountPrice">折后价：￥{{item.discountPrice}}</div>
                        <div class="toto" v-if="!item.discountPrice">---</div>
                        <div class="toto">{{item.qrcBuyCount}}{{item.goodsUnit}}</div>
                        <div>{{item.totalDiscountPrice ? '折后价总计：'+ item.totalDiscountPrice : '原价总计：'+ item.totalRetailPrice}}</div>
                        <!-- <div class="toto">小计：￥{{item.totalTurnoverPrice}}</div> -->
                      </div>
                    </div>
                    <div
                      style="margin-left:20px;color:gray;margin-bottom:20px"
                      v-if="item1.products.length>5"
                    >等{{item1.products.length}}个商品</div>
                  </div>
                  <div class="price column">
                    <div>总数：{{item1.qrcBuyCount}}</div>
                    <div>合计：￥{{item1.totalRetailPrice }}</div>
                    <div
                      v-if="item1.shopPromotionData.length!=0"
                    >{{item1.shopPromotionData[0].name}}</div>
                    <div v-else>优惠券：无</div>
                    <div>优惠：￥{{item1.totalDiscountPrice}}</div>
                    <div>
                      应收金额：
                      <span style="color:red">￥{{item1.gainMoney}}</span>
                    </div>
                  </div>
                  <div class="state alignCenter column">
                    <div style="margin-top:27px;">{{item1.orderStatus}}</div>
                    <div @click="hrefDetail(item1)" class="orderJump">订单详情</div>
                  </div>
                  <div id="operate" class="operate justCenter">
                    <div style="margin-top:27px">
                      <!-- <el-button size="small" type="primary">打印小票</el-button>
                      <el-button size="small">去发货</el-button>-->
                      <el-button size="small" @click="open(item1)">备注</el-button>
                    </div>
                  </div>
                </div> 
                <div class="bottom" v-if="item1.orderMark || item1.refundRemark">
                  <div>
                    商家备注：
                    <span style="color:red">{{item1.orderMark}}</span>
                  </div>
                  <div v-if="item1.refundRemark">
                    退款备注：
                    <span style="color:red">{{item1.refundRemark}}</span>
                  </div>
                </div>
              </div>
              <!-- //分页 -->
              <div class="block" style="float:right;margin-top:10px;">
                <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage4"
                  :page-size="10"
                  layout="total, prev, pager, next, jumper"
                  :total="totalCount"
                ></el-pagination>
              </div>
            </div>
            <div v-else style="margin-top:20px">暂无订单信息</div>
          </el-tab-pane>
          <el-tab-pane label="已退款" name="seventh">
            <div v-if="isShow">
              <div class="table" v-for="(item1,index1) in commodityList.list" :key="index1">
                <div class="tableHead row">
                  <div>创建时间：{{item1.createTime}}</div>
                  <div>订单号：{{item1.tradeNo}}</div>
                  <div class="alignCenter">
                    <img style="margin-right:5px;" src="../../assets/icon/ggmd.png" alt />
                    {{item1.shopName}}
                  </div>
                  <div v-if="item1.orderCategory = 10">钱如潮订单</div>
                </div>
                <div class="commodityList row">
                  <div class="commodity">
                    <div
                      v-for="(item,index) in item1.products"
                      @click="hrefDetail(item1)"
                      :key="index"
                    >
                      <div v-if="index<5" class="commodityItem row alignCenter">
                       <div class="totoName">{{item.goodsName}} <span v-if="item.specDesc">({{item.specDesc}})</span></div>
                        <div class="toto">单价：￥{{item.retailPrice}}</div>
                        <div class="toto" v-if="item.discountPrice">折后价：￥{{item.discountPrice}}</div>
                        <div class="toto" v-if="!item.discountPrice">---</div>
                        <div class="toto">{{item.qrcBuyCount}}{{item.goodsUnit}}</div>
                        <div>{{item.totalDiscountPrice ? '折后价总计：'+ item.totalDiscountPrice : '原价总计：'+ item.totalRetailPrice}}</div>
                        <!-- <div class="toto">小计：￥{{item.totalTurnoverPrice}}</div> -->
                      </div>
                    </div>
                    <div
                      style="margin-left:20px;color:gray;margin-bottom:20px"
                      v-if="item1.products.length>5"
                    >等{{item1.products.length}}个商品</div>
                  </div>
                  <div class="price column">
                    <div>总数：{{item1.qrcBuyCount}}</div>
                    <div>合计：￥{{item1.totalRetailPrice }}</div>
                    <div
                      v-if="item1.shopPromotionData.length!=0"
                    >{{item1.shopPromotionData[0].name}}</div>
                    <div v-else>优惠券：无</div>
                    <div>优惠：￥{{item1.totalDiscountPrice}}</div>
                    <div>
                      应收金额：
                      <span style="color:red">￥{{item1.gainMoney}}</span>
                    </div>
                      <div v-if="item1.orderStatus == '有退款'|| item1.orderStatus == '有退款退货'">
                      退款金额：
                      <span style="color:red">￥{{item1.refundMoney}}</span>
                    </div>
                  </div>
                  <div class="state alignCenter column">
                    <div style="margin-top:27px">{{item1.orderStatus}}</div>
                    <div @click="hrefDetail(item1)" class="orderJump">订单详情</div>
                  </div>
                  <div id="operate" class="operate justCenter">
                    <div style="margin-top:27px">
                      <!-- <el-button size="small" type="primary">打印小票</el-button>
                      <el-button size="small">去发货</el-button>-->
                      <el-button size="small" @click="open(item1)">备注</el-button>
                    </div>
                  </div>
                </div>
                <!-- v-if="item1.orderMark"  -->
                <div class="bottom" v-if="item1.orderMark || item1.refundRemark">
                  <div v-if="item1.orderMark">
                    商家备注：
                    <span style="color:red">{{item1.orderMark}}</span>
                  </div>
                   <div v-if="item1.refundRemark">
                    退款备注：
                    <span style="color:red">{{item1.refundRemark}}</span>
                  </div>
                </div>
              </div>
              <!-- //分页 -->
              <div class="block" style="float:right;margin-top:10px;">
                <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage4"
                  :page-size="10"
                  layout="total, prev, pager, next, jumper"
                  :total="totalCount"
                ></el-pagination>
              </div>
            </div>
            <div v-else style="margin-top:20px">暂无订单信息</div>
          </el-tab-pane>
          <el-tab-pane label="已退货退款" name="ninth">
            <div v-if="isShow">
              <div class="table" v-for="(item1,index1) in commodityList.list" :key="index1">
                <div class="tableHead row">
                  <div>创建时间：{{item1.createTime}}</div>
                  <div>订单号：{{item1.tradeNo}}</div>
                  <div class="alignCenter">
                    <img style="margin-right:5px;" src="../../assets/icon/ggmd.png" alt />
                    {{item1.shopName}}
                  </div>
                  <div v-if="item1.orderCategory = 10">钱如潮订单</div>
                </div>
                <div class="commodityList row">
                  <div class="commodity">
                    <div
                      v-for="(item,index) in item1.products"
                      @click="hrefDetail(item1)"
                      :key="index"
                    >
                      <div v-if="index<5" class="commodityItem row alignCenter">
                 <div class="totoName">{{item.goodsName}} <span v-if="item.specDesc">({{item.specDesc}})</span></div>
                        <div class="toto">单价：￥{{item.retailPrice}}</div>
                        <div class="toto" v-if="item.discountPrice">折后价：￥{{item.discountPrice}}</div>
                        <div class="toto" v-if="!item.discountPrice">---</div>
                        <div class="toto">{{item.qrcBuyCount}}{{item.goodsUnit}}</div>
                        <div>{{item.totalDiscountPrice ? '折后价总计：'+ item.totalDiscountPrice : '原价总计：'+ item.totalRetailPrice}}</div>
                        <!-- <div class="toto">小计：￥{{item.totalTurnoverPrice}}</div> -->
                      </div>
                    </div>
                    <div
                      style="margin-left:20px;color:gray;margin-bottom:20px"
                      v-if="item1.products.length>5"
                    >等{{item1.products.length}}个商品</div>
                  </div>
                  <div class="price column">
                    <div>总数：{{item1.qrcBuyCount}}</div>
                    <div>合计：￥{{item1.totalRetailPrice }}</div>
                    <div
                      v-if="item1.shopPromotionData.length!=0"
                    >{{item1.shopPromotionData[0].name}}</div>
                    <div v-else>优惠券：无</div>
                    <div>优惠：￥{{item1.totalDiscountPrice}}</div>
                    <div>
                      应收金额：
                      <span style="color:red">￥{{item1.gainMoney}}</span>
                    </div>
                      <div v-if="item1.orderStatus == '有退款'|| item1.orderStatus == '有退款退货'">
                      退款金额：
                      <span style="color:red">￥{{item1.refundMoney}}</span>
                    </div>
                  </div>
                  <div class="state alignCenter column">
                    <div style="margin-top:27px">{{item1.orderStatus}}</div>
                    <div @click="hrefDetail(item1)" class="orderJump">订单详情</div>
                  </div>
                  <div id="operate" class="operate justCenter">
                    <div style="margin-top:27px">
                      <!-- <el-button size="small" type="primary">打印小票</el-button>
                      <el-button size="small">去发货</el-button>-->
                      <el-button size="small" @click="open(item1)">备注</el-button>
                    </div>
                  </div>
                </div>
                <div class="bottom" v-if="item1.orderMark || item1.refundRemark">
                  <div v-if="item1.orderMark">
                    商家备注：
                    <span style="color:red">{{item1.orderMark}}</span>
                  </div>
                   <div v-if="item1.refundRemark">
                    退款备注：
                    <span style="color:red">{{item1.refundRemark }}</span>
                  </div>
                </div>
              </div>
              <!-- //分页 -->
              <div class="block" style="float:right;margin-top:10px;">
                <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage4"
                  :page-size="10"
                  layout="total, prev, pager, next, jumper"
                  :total="totalCount"
                ></el-pagination>
              </div>
            </div>
            <div v-else style="margin-top:20px">暂无订单信息</div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import { shopWorkersForType } from "../api";
export default {
  name: "orderManagement",
  data() {
    return {
      totalCount: 0,
      loading:false,
      shopId: "", //门店id
      value1: "", //日期默认
      activeName: "first", //订单标签栏默认
      currentPage4: 1, //页数
      content: "",
      //日期选择器选择时间
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              // start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      commodityList: [
        {
          time: "2019-4-2 9:31:23",
          id: "E2019837291023",
          shopName: "狗狗门店",
          type: "普通订单",
          content: "无",
          commodity: [
            {
              img: require("../../assets/icon/red.png"),
              price: 8.0,
              down: "9",
              num: 2,
              name: "散装休闲食品，咸松小饼干小零食早餐代餐食品",
              type: "8237492837182742"
            },
            {
              img: require("../../assets/icon/red.png"),
              price: 8.0,
              down: "9",
              num: 2,
              name: "散装休闲食品，咸松小饼干小零食早餐代餐食品",
              type: "8237492837182742"
            }
          ]
        },
        {
          time: "2019-4-2 9:31:23",
          id: "E2019837291023",
          shopName: "狗狗门店",
          type: "会员订单",
          content: "无",
          commodity: [
            {
              img: require("../../assets/icon/blue.png"),
              price: 8.0,
              down: "9",
              num: 2,
              name: "散装休闲食品，咸松小饼干小零食早餐代餐食品",
              type: "8237492837182742"
            },
            {
              img: require("../../assets/icon/orange.png"),
              price: 8.0,
              down: "9",
              num: 2,
              name: "散装休闲食品，咸松小饼干小零食早餐代餐食品",
              type: "8237492837182742"
            }
          ]
        }
      ],
      userList: "", //用户信息
      shopInformation: "", //店铺信息
      pageNo: 1,
      orderStatus: "",
      tradeNo: "",
	  phoneNum:"",
      isShow: false,
      workerList: [],
      shopList: [
        { storeName: "全部门店", shopStoreId: "" }
        //门店地址数组
      ],
      cashierId: null,
      salesId: null,
      tableData: '',
      status: null
    };
  },
  created(startDate, endDate) {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
    
    this.Shop_shopStores();
    this.shopWorkersForType();
    var goodsId = this.$route.query.goodsId
    var productId = this.$route.query.productId
    var orderDate = this.$route.query.orderDate
    if (goodsId) {
      console.log(1)
      this.MallOrder_mallOrdersForManager('', '', '', '', '', '', 1, goodsId, productId, orderDate); //订单列表
    } else {
      console.log(2)
      this.MallOrder_mallOrdersForManager(); //订单列表
    }
  },
  destroyed() {
    localStorage.removeItem("searchContent")
  },
  methods: {
    shopWorkersForType(workerType) {
      shopWorkersForType({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        workerTypes: "100,101,102",
        row: 9999
      }).then(res => {
        console.log(res, "员工列表");
        if (res.code == 1) {
          this.workerList = res.data;
          this.workerList.cashierList.unshift(this.workerList.shoperList[0])
        }
      });
    },
    Shop_shopStores(pageNo) {
      this.request
        .post("qrcapi/Shop_shopStores", {
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          pageNo: pageNo,
          row: 10
        })
        .then(res => {
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            // var totalMoney = 0;
            // for (let i in res.data) {
            //   totalMoney += Number(res.data[i].gainMoney);
            // }
            // this.totalMoney = totalMoney;
            for (let i in res.data.list) {
              this.shopList.push(res.data.list[i]);
            }
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 订单列表
    MallOrder_mallOrdersForManager(
      orderStatus,
      startDate,
      endDate,
      tradeNo,
      cashierUserId,
      saleUserId,
      pageNumber,
      goodsId,
      productId,
      orderDate
    ) {
      this.commodityList = []
      this.loading = true
      this.request
        .post("qrcapi/MallOrder_mallOrdersForManager", {
          orderStatus: orderStatus,
          //订单状态  10,"未付款"  20,"等待发货"  30,"等待确认收货"   40,"完成"  -10,"关闭"  -20,	"取消"  -21,"申请退款"  -25,"退款中"  -50,"退款"
          //  Long shopStoreId; // 门店Id [可选] 若不传 则为所有门店
          sessionId: this.userList.sessionId,
          userId: this.userList.id,
          startDate: startDate, //筛选开始时间 [可选]
          endDate: endDate, //结束时间 [可选]
          tradeNo: tradeNo,
		  phoneNum: this.phoneNum,
          shopStoreId: this.shopId, // 门店Id [可选] 若不传 则为所有门店
          //  payInterfacePartyType:payInterfacePartyType,  //使用哪个支付 [可选]   1.系统  2.支付宝   3.微信
          pageNumber: this.pageNo,
          pageSize: 10,
          cashierUserId: cashierUserId,
          saleUserId: saleUserId,
          productId: productId ,
          goodsId: goodsId,
          orderDate: orderDate
        })
        .then(res => {
          console.log(res, "订单列表");
          if (res.data.list.length == 0) {
            this.pageNo = "";
          }
          if (res.code == 1) {
            // this.$message({
            //   message: res.msg,
            //   type: "success"
            // });
            let comidArr = res.data;
            for (let i in comidArr.list) {
              comidArr.list[i].shopPromotionData = JSON.parse(
                comidArr.list[i].shopPromotionData
              );
            }
            this.commodityList = comidArr;
            this.totalCount = this.commodityList.totalCount
            console.log(this.commodityList, "123221");
            if (res.data.list.length) {
              this.isShow = true;
            } else {
              this.isShow = false;
            }
            for (let i in this.commodityList.list) {
              var qrcBuyCount = 0;
              var retailPrice = 0;
              var totalDiscounts = 0;
              switch (this.commodityList.list[i].orderStatus) {
                case 10:
                  this.commodityList.list[i].orderStatus = "未付款";
                  break;
                case 20:
                  this.commodityList.list[i].orderStatus = "等待发货";
                  break;
                case 30:
                  this.commodityList.list[i].orderStatus = "等待确认收货";
                  break;
                case 40:
                  this.commodityList.list[i].orderStatus = "完成";
                  break;
                case -10:
                  this.commodityList.list[i].orderStatus = "关闭";
                  break;
                case -20:
                  this.commodityList.list[i].orderStatus = "取消";
                  break;
                case -21:
                  this.commodityList.list[i].orderStatus = "申请退款";
                  break;
                case -25:
                  this.commodityList.list[i].orderStatus = "退款中";
                  break;
                case -50:
                  this.commodityList.list[i].orderStatus = "有退款";
                  break;
                case -51:
                  this.commodityList.list[i].orderStatus = "有退款退货";
                  break;
              }
              for (let j in this.commodityList.list[i].products) {
                qrcBuyCount += this.commodityList.list[i].products[j].qrcBuyCount;
                retailPrice +=
                  this.commodityList.list[i].products[j].retailPrice *
                  this.commodityList.list[i].products[j].qrcBuyCount;
                // console.log(this.commodityList.list[i].products[j], "321");
                totalDiscounts += this.commodityList.list[i].products[j]
                  .discountPrice;
              }
              // console.log(totalDiscounts, "totalDiscountstotalDiscounts");
              this.$set(this.commodityList.list[i], "totalCount", qrcBuyCount);
              this.$set(this.commodityList.list[i], "totalRetailPrice", retailPrice.toFixed(2));
              this.$set( this.commodityList.list[i], "totalDiscounts", totalDiscounts.toFixed(2));
            }
            this.loading = false
            // console.log(this.commodityList, " this.commodityList");
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    //标签栏
    handleClick(tab, event) {
      console.log(tab.name);
      // console.log( event);
      var orderStatus = this.orderStatus;
      switch (tab.name) {
        case "first":
          orderStatus = "";
          break;
        case "second":
          orderStatus = 10;
          break;
        case "fifth":
          orderStatus = 40;
          break;
        case "sixth":
          orderStatus = -10;
          break;
        case "seventh":
          orderStatus = -50;
          break;
        case "ninth":
          orderStatus = -51;
          break;
      }
      this.orderStatus = orderStatus;
      this.MallOrder_mallOrdersForManager(orderStatus); //订单列表
    },
    //分页选择每页多少条
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //分页当前页
    handleCurrentChange(val) {
      this.pageNo = val;
      var data = this.value1;
      var searchContent = ""
      searchContent = localStorage.getItem("searchContent")
      if (data || this.status == 1) {
        this.MallOrder_mallOrdersForManager(this.orderStatus, data[0], data[1], searchContent); //订单列表
      } else {
        this.MallOrder_mallOrdersForManager(this.orderStatus, "", ""); //订单列表
      }

      console.log(`当前页: ${val}`);
    },
    //备注弹出框
    open(item) {
      console.log(item);
      this.$prompt("请输入备注", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputType:'textarea',
        inputValue:item.orderMark
      })
        .then(({ value }) => {
          // item.content = value;

          // this.$message({
          //   type: 'success',
          //   message: '你的邮箱是: ' + value
          // });
          this.request
            .post("qrcapi/MallOrder_saveOrderMark", {
              sessionId: this.userList.sessionId,
              userId: this.userList.id,
              mallOrderId: item.mallOrderId, //订单id
              orderMark: value //备注
            })
            .then(res => {
              console.log(res, "添加备注");
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                this.MallOrder_mallOrdersForManager(); //订单列表
              } else if (res.code == 2) {
                this.$message.error(res.msg);
                this.$router.push("/");
              } else {
                this.$message.error(res.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入"
          });
        });
    },
    //跳转订单详情页
    hrefDetail(item) {
      console.log(item.tradeNo)
      this.$router.push({
        path: "orderDetails",
        query: { 
          name: item.mallOrderId,
          tradeNo: item.tradeNo
        }
      });
    },
    //搜索
    search() {
      this.status = 1
      var data = this.value1;
      var tradeNo = this.tradeNo;
      console.log(tradeNo, "tradeNo");
      tradeNo = tradeNo.replace(/(^\s+)|(\s+$)/g, "");
      localStorage.setItem("searchContent", tradeNo)
      if (data) {
        this.MallOrder_mallOrdersForManager(
          this.orderStatus,
          data[0],
          data[1],
          tradeNo,
          this.cashierId,
          this.salesId
        );
      } else {
        this.MallOrder_mallOrdersForManager(
          this.orderStatus,
          "",
          "",
          tradeNo,
          this.cashierId,
          this.salesId
        );
      }
      console.log(data);
    },
    searchContentBlur(e) {
      if (e.target.value.length == 0) {
        localStorage.removeItem("searchContent")
      }
    },
    clearSearch() {
      this.value1 = "";
      this.tradeNo = "";
      this.shopId = "";
      this.salesId = "";
      this.cashierId = "";
      localStorage.removeItem("searchContent")
    }
  }
};
</script>

<style scoped>
.head {
  box-sizing: border-box;
  padding: 30px 25px;
  background: #f8f8f8;
  width: 100%;
  padding-top: 80px;
}
/* .head .el-input__inner {
  height: 24px;
} */
.headInput {
  width: 170px;
}
.headText {
  line-height: 40px;
  margin: 0 10px;
}
.content {
  box-sizing: border-box;
  background: #fff;
  height: calc(100vh - 210px);
  /* width: 100%; */
  width: calc(100vw - 250px);
  padding: 30px 25px;
}
.table {
  width: 99.9%;
  border: 1px solid #e4e7ed;
  margin-top: 20px;
  font-size: 12px;
}
.tableHead {
  background: #f8f8f8;
  width: 100%;
  border-bottom-color: 1px solid #e4e7ed;

  color: gray;
  line-height: 40px;
}
.tableHead div {
  margin-left: 20px;
}
.commodityList {
  width: 100%;
  border-top: 1px solid #e4e7ed;
}
.price {
  box-sizing: border-box;
  width: 12%;
  border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
  padding: 20px 10px;
  padding-left: 40px;
}
.price div,
.state div {
  margin-top: 15px;
}
.state {
  width: 12%;
  border-right: 1px solid #e4e7ed;
}
.operate {
  width: 18%;
}
.commodity {
  width: 58%;
}
.commodity img {
  width: 63px;
  height: 63px;
}
/* .commodityItem:not(:last-child) {
  border-bottom: 1px solid #e4e7ed;
} */
.commodityItem {
  /* height: 110px; */
  padding: 10px 0;
  font-size: 12px;
}
.block{
  margin-bottom: 20px;
}
.toto {
  margin-left: 80px;
  width: 100px;
}
.bottom {
  padding: 19px;
  border-top: 1px solid #e4e7ed;
  font-size: 12px;
}
.orderJump:hover {
  color: #409eff;
  cursor: pointer;
}
.totoName {
  width: 100px;
  margin-left: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/page/orderManagment.vue